import { render, staticRenderFns } from "./OntechPadSettings.vue?vue&type=template&id=5f31d910&scoped=true"
import script from "./OntechPadSettings.vue?vue&type=script&lang=js"
export * from "./OntechPadSettings.vue?vue&type=script&lang=js"
import style0 from "./OntechPadSettings.vue?vue&type=style&index=0&id=5f31d910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31d910",
  null
  
)

export default component.exports